<div class="g-0">
    <div class="col">
        <div class="box-wrapper box-documents">
            <div class="box-content-header">
                <div class="row p-1">
                    <div class="col">
                        <div class="px-2 d-flex justify-content-between align-items-center">
                            <div>
                                <i class="fa-solid fa-location-crosshairs"></i>
                                <span class="ms-2">Locație Proiect</span>
                            </div>
                            <button
                                *ngIf="permissionsService.hasPermission('monitoring-module.proiecte.proiecte-view.update')"
                                class="btn btn-small btn-primary edit-btn" (click)="toggleEditField()">
                                <i class="fa fa-pencil" *ngIf="!showEditField"></i>
                                <i class="fa fa-close" *ngIf="showEditField"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-content-body">

                <div id="map" style="height:300px; width:100%"></div>

                <ng-container *ngIf="!showEditField">
                    <div class="row py-1 mx-1 bg">
                        <div class="col-6">
                            <div class="fw-bold">Locația proiectului</div>
                        </div>
                    </div>
                    <div class="row py-1 mx-1">
                        <div class="col-6">
                            <div class="">{{ addressName || 'n/a' }}</div>
                        </div>
                    </div>
                    <div class="row py-1 mx-1 bg">
                        <div class="col-6">
                            <div class="fw-bold">Observații locație</div>
                        </div>
                    </div>
                    <div class="row py-1 mx-1">
                        <div class="col-6">
                            <div class="">{{ proiect.locatie_obs || 'n/a' }}</div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="showEditField">
                    <form class="p-1" [formGroup]="form" (submit)="submitForm()">
                        <div class="row">
                            <div class="col">
                                <mat-form-field class="w-100" appearance="fill">
                                    <mat-label>Locația proiectului</mat-label>
                                    <input type="text" matInput formControlName="addressName"
                                        [matAutocomplete]="places" />
                                    <mat-icon matSuffix class="opacity-50">search</mat-icon>
                                    <mat-autocomplete #places="matAutocomplete">
                                        <mat-option *ngFor="let place of searchedPlaces" [value]="place.locatie"
                                            (onSelectionChange)="onPlaceSelected(place)">
                                            {{ place.locatie }}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-error
                                        *ngIf="!form.controls['addressName'].valid && form.controls['addressName'].touched">
                                        Câmp obligatoriu
                                    </mat-error>
                                </mat-form-field>
                                <mat-error
                                    *ngIf="(!form.controls['lat'].valid || !form.controls['lng'].valid) && form.controls['addressName'].touched"
                                    class="mb-2">
                                    Selectați o adresă!
                                </mat-error>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <mat-form-field class="w-100" appearance="fill">
                                    <mat-label>Observații locație</mat-label>
                                    <textarea matInput formControlName="addressObs" name="addressObs"></textarea>
                                    <mat-error
                                        *ngIf="!form.controls['addressObs'].valid && form.controls['addressObs'].touched">
                                        Câmp obligatoriu
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col d-flex justify-content-between">
                                <button type="button" class="btn btn-small btn-warning" (click)="closeEditField()">
                                    Închide
                                </button>
                                <button type="submit" class="btn btn-small btn-primary" [disabled]="form.invalid">
                                    Salvează
                                </button>
                            </div>
                        </div>
                    </form>
                </ng-container>

            </div>

            <div class="section-spinner position-fixed" *ngIf="isLoading">
                <div class="spinner position-absolute top-50 start-50 translate-middle">
                    <mat-spinner></mat-spinner>
                    <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                </div>
            </div>

        </div>
    </div>
</div>